export interface UserConsentWorkFlowSchema {
    type: 'object';
    properties: {
        permissionGrantPolicyIdsAssignedToDefaultUserRole: {
            type: 'array';
            items: {
                type: 'string';
                enum: string[];
            };
            minItems: number;
            maxItems: number;
            uniqueItems: true;
        };
    };
    required: ['permissionGrantPolicyIdsAssignedToDefaultUserRole'];
}

export function getUserConsentPolicyDesiredValueInPlainText(
    permissionGrantPolicyIdsAssignedToDefaultUserRole: string[],
): string {
    if (
        permissionGrantPolicyIdsAssignedToDefaultUserRole.includes(
            'ManagePermissionGrantsForSelf.microsoft-user-default-low',
        )
    ) {
        return 'Allow user consent for apps from verified publishers, for selected permissions';
    } else if (
        permissionGrantPolicyIdsAssignedToDefaultUserRole.includes(
            'ManagePermissionGrantsForSelf.microsoft-user-default-legacy',
        ) ||
        permissionGrantPolicyIdsAssignedToDefaultUserRole.includes(
            'ManagePermissionGrantsForSelf.microsoft-user-default-recommended',
        )
    ) {
        return 'Allow user consent for apps';
    } else {
        return 'An administrator will be required for all apps.';
    }
}

export function getUserConsentPolicyDesiredValue(permissionGrantPolicyIdsAssignedToDefaultUserRole: string[]): string {
    if (
        permissionGrantPolicyIdsAssignedToDefaultUserRole.includes(
            'ManagePermissionGrantsForSelf.microsoft-user-default-low',
        )
    ) {
        return 'verifiedUsers';
    } else if (
        permissionGrantPolicyIdsAssignedToDefaultUserRole.includes(
            'ManagePermissionGrantsForSelf.microsoft-user-default-legacy',
        ) ||
        permissionGrantPolicyIdsAssignedToDefaultUserRole.includes(
            'ManagePermissionGrantsForSelf.microsoft-user-default-recommended',
        )
    ) {
        return 'allUsers';
    } else {
        return 'noUsers';
    }
}

export function generateUserConsentPolicySchema(
    value: 'verifiedUsers' | 'allUsers' | 'noUsers',
): UserConsentWorkFlowSchema {
    let itemsLength = 2;
    const enumValue = [
        'ManagePermissionGrantsForOwnedResource.microsoft-dynamically-managed-permissions-for-chat',
        'ManagePermissionGrantsForOwnedResource.microsoft-dynamically-managed-permissions-for-team',
    ];

    if (value === 'verifiedUsers') {
        itemsLength = 3;
        enumValue.push('ManagePermissionGrantsForSelf.microsoft-user-default-low');
    } else if (value === 'allUsers') {
        // Graph stores `microsoft-user-default-legacy` as Microsoft's managed pair, so desire the pair (OS-454).
        itemsLength = 4;
        enumValue.push(
            'ManagePermissionGrantsForSelf.microsoft-user-default-recommended',
            'ManagePermissionGrantsForSelf.microsoft-user-default-allow-consent-apps',
        );
    }

    return {
        type: 'object',
        properties: {
            permissionGrantPolicyIdsAssignedToDefaultUserRole: {
                type: 'array',
                items: {
                    type: 'string',
                    enum: enumValue,
                },
                minItems: itemsLength,
                maxItems: itemsLength,
                uniqueItems: true,
            },
        },
        required: ['permissionGrantPolicyIdsAssignedToDefaultUserRole'],
    };
}
